import { useCallback, useRef, useState } from 'react'

interface IConfirmationState {
  isVisible: boolean
}

/**
 * Promise-based confirmation primitive (same shape as the one in businessPriorities —
 * copied locally to keep the FSD no-cross-feature-import rule). `confirm()` opens the
 * dialog and resolves to `true` on confirm / `false` on cancel.
 */
export const useConfirmation = () => {
  const [state, setState] = useState<IConfirmationState>({ isVisible: false })
  const resolverRef = useRef<((confirmed: boolean) => void) | null>(null)

  const confirm = useCallback(() => {
    setState({ isVisible: true })

    return new Promise<boolean>((resolve) => {
      resolverRef.current = resolve
    })
  }, [])

  const settle = useCallback((confirmed: boolean) => {
    setState({ isVisible: false })
    resolverRef.current?.(confirmed)
    resolverRef.current = null
  }, [])

  return {
    confirm,
    dialogProps: {
      isVisible: state.isVisible,
      onConfirm: () => settle(true),
      onReject: () => settle(false),
    },
  }
}
